module.exports = __webpack_public_path__ + "static/media/waterKeepButton.e22ebb95.png";